import {client} from './client';
import {country} from './country';

export const organisation = function (item = null) {
    return {
        id: item == null ? null : item.id,
        name: item == null ? null : item.name,
        address: item == null ? null : item.address,
        country: country(item == null ? null : item.country),
        postalCode: item == null ? null : item.postalCode,
        city: item == null ? null : item.city,
        additionalAddress: item == null ? null : item.additionalAddress,
        numSiret: item == null ? null : item.numSiret,
        phone: item == null ? null : item.phone,
        phoneNumberCode: item == null ? null : item.phoneNumberCode,
        taxRegistrationNumber: item == null ? null : item.taxRegistrationNumber,
        website: item == null ? null : item.website,
        timezone: item == null ? null : item.timezone,
        client: client(item == null ? null : item.client),
        linkToStark: item == null ? null : item.linkToStark,

    };
};
